<!-- 模块-绑定和解绑油卡 -->
<template>
  <van-popup class="popup" v-model="ifShow" position="right" :overlay="false">
    <div class="popup_title">
      <span>{{type == 1 ? '绑定实体油卡' : '解除绑定'}}</span>
      <van-button type="default" round size="small" @click="close">返 回</van-button>
    </div>

    <v-touch class="popup_body" @swiperight="close">
      <van-form @submit="on">
        <van-field
          :readonly="type === 2"
          type="number"
          v-model="card_no"
          label="油卡卡号:"
          placeholder="油卡背面卡号"
          :rules="[{ validator: ver_card_no, message: '请输入有效卡号' }]"
        />

        <van-field
          v-model="pw"
          type="password"
          label="油卡密码:"
          placeholder="6位数字密码"
          :rules="[{ validator: ver_pw, message: '请输入有效密码' }]"
        />

        <van-field
          v-if="$root.co_type === 1"
          :readonly="type === 2"
          type="number"
          v-model="card_phone"
          label="手机号:"
          placeholder="手机号"
          :rules="[{ validator: ver_phone, message: '请输入有效手机号' }]"
        />

        <van-field
          v-if="type === 1 && $root.co_type === 0"
          readonly
          v-model="c_type_name"
          label="证件类型:"
          placeholder="选择证件类型"
          @click="show_type = true"
        />

        <van-field
          v-if="type === 1 && $root.co_type === 0"
          v-model="c_num"
          label="证件号码:"
          placeholder="请输入证件号码"
          :rules="[{ validator: ver_num, message: '证件号码无效' }]"
        />

        <div class="footer" v-show="$root.systemKeyboard" >
          <van-button round block type="info" native-type="submit" :loading="ifOn" :disabled="ifOn">{{type == 1 ? '绑定油卡' : '解绑油卡'}}</van-button>
        </div>
      </van-form>
    </v-touch>

    <!-- 选择证件类型 -->
    <van-popup v-model="show_type" round position="bottom">
      <van-picker show-toolbar :columns="type_data" @cancel="show_type = false" @confirm="choose_type"/>
    </van-popup>
  </van-popup>
</template>

<script>
export default {
  name: 'card_into_del',
  data () {
    return {
      ifShow: false,
      ifOn: false,
      show_type: false,
      type: 1,
      card_no: '',
      pw: '',
      card_phone: '',
      c_type_name: '身份证',
      c_type: 1,
      c_num: '',
      type_data: ['身份证', '居住证', '护照', '军人证', '团员证', '党员证']
    }
  },

  methods: {
    // 显示弹层
    show (data) {
      this.type = data.type
      if (this.type === 1) {
        this.card_no = ''
      } else {
        this.card_no = data.data.card_no
      }
      this.pw = ''
      this.card_phone = ''
      this.c_num = ''
      this.ifShow = true
    },

    // 选择证件类型
    choose_type (val, key) {
      this.c_type_name = val
      this.c_type = key + 1
      this.show_type = false
    },

    // 验证卡号是否正确
    ver_card_no (val) {
      return true

      // if (val.length < 6) {
      //   return false
      // } else {
      //   return true
      // }
    },

    // 验证密码是否有效
    ver_pw (val) {
      if (val.length !== 6) {
        return false
      } else {
        return true
      }
    },

    // 验证证件号码是否正确
    ver_num (val) {
      if (this.c_type === 1) {
        return this.ver_input(3, val)
      } else {
        if (val.length === 0) {
          return false
        } else {
          return true
        }
      }
    },

    // 验证手机号是否正确
    ver_phone (val) {
      return true

      // if (val.length < 11) {
      //   return false
      // } else {
      //   return true
      // }
    },

    // 提交数据
    on () {
      let api = ''
      if (this.type === 1) {
        api = 'into_web_card_user'
      } else {
        api = 'del_web_card_user'
      }

      let data = {
        card_no: this.card_no,
        pw: this.pw,
        phone: this.card_phone,
        c_type: this.c_type,
        c_num: this.c_num
      }

      this.ax(this, api, data, (res) => {
        if (res.err_num === 0) {
          this.close()
        }
      }, 'on')
    },

    // 关闭
    close () {
      this.$emit('up_data')
      this.ifShow = false
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/card/into_del.vue